import e, { useMemo as i } from "react";
import { QueryClient as l, QueryClientProvider as m } from "react-query";
import { I18NProvider as c } from "../../../i18n/i18n.js";
const u = e.createContext(null);
function f(t) {
  const {
    children: r,
    env: n
  } = t, o = i(() => new l(), []);
  return /* @__PURE__ */ e.createElement(u.Provider, { value: n }, /* @__PURE__ */ e.createElement(c, null, /* @__PURE__ */ e.createElement(m, { client: o }, r)));
}
export {
  u as EnvironmentContext,
  f as EnvironmentProvider
};
//# sourceMappingURL=context.js.map
